import {getFallbackGameImage} from "@assets/images/fallbackGameImage";
import {getProviderDisplayName} from "@/util/providerNames";

const resolveProvider = game => {
  if (typeof game.provider === "object" && game.provider?.name) {
    return game.provider.name;
  }
  return game.provider || game.game_provider || "";
};

const resolveIcon = (game, meta) => {
  if (meta?.icon) return meta.icon;
  if (game.icon) return game.icon;
  if (game.thumbnail_url?.trim()) return game.thumbnail_url.trim();
  if (game.custom_icon?.trim()) {
    if (game.custom_icon.startsWith("http")) return game.custom_icon;
    return `https://images.cdn.randrush.com/${game.custom_icon}`;
  }
  return getFallbackGameImage();
};

export const normalizeCarouselGame = (game, getGameById) => {
  const provider = resolveProvider(game);
  const gameId = game.game_id || game.provider_game_id || game.id;
  const meta = getGameById?.(gameId, provider);

  const providerLabel =
    meta?.provider_display_name ||
    game.provider_display_name ||
    getProviderDisplayName(provider) ||
    provider;

  const name = meta?.name || game.name || game.game_name || gameId || "";

  return {
    id: gameId,
    provider,
    name,
    icon: resolveIcon(game, meta),
    providerLabel,
  };
};
